<div [class]="'app-header header-shadow ' + (config$ | async).headerTheme" style="background-color: rgb(226, 226, 226);height:40px;">
 
  <div style="width: 100%; background-color: rgb(226, 226, 226);">
    <!-- First Row: Sidebar -->
    <div class="row" style="width: 100%;height:30px;padding: 0px;">
      <div style="width: 96.5%;height:30px" >
        <app-sidebar *ngIf="isAdmin"></app-sidebar>
        <dynamic-sidebar-list *ngIf="!isAdmin"></dynamic-sidebar-list>
      </div>
      <div class="col-12" style="left: 8.5%;">
        <app-user-box></app-user-box>
      </div>
    </div>
  </div>
</div>
